export const getTestSchemes = (schemes) => {
  return schemes?.filter((scheme) => scheme.attributes.status === 'test');
};

export const getActiveSchemes = (schemes) => {
  return schemes?.filter((scheme) => scheme.attributes.status === 'active');
};
